import { ColorPicker } from '@shared/components/atoms/ColorPicker';

import type { ISelectedOption } from '@/components/atoms/SelectField';
import SelectField from '@/components/atoms/SelectField';

interface FontFamilyOption {
  value: string;
  label: string;
}

interface StyleSectionProps {
  title: string;
  fieldPrefix: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getValue: (field: string) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValueForField: (field: string, value: any) => void;
  messages: {
    fontColorLabel: () => string;
    backgroundColorLabel: () => string;
    fontFamilyLabel: () => string;
    boldLabel: () => string;
    italicLabel: () => string;
  };
  fontFamilyOptions: FontFamilyOption[];
}

export const StyleSection = ({
  title,
  fieldPrefix,
  getValue,
  setValueForField,
  messages,
  fontFamilyOptions,
}: StyleSectionProps) => {
  return (
    <div className='border-white-light dark:border-c16 mb-6 rounded-lg border p-4'>
      <h6 className='mb-4 text-sm font-medium text-gray-900 dark:text-gray-100'>{title}</h6>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
        <div>
          <ColorPicker
            color={getValue(`${fieldPrefix}FontColor`) || '#000000'}
            onChange={(color) => setValueForField(`${fieldPrefix}FontColor`, color)}
            label={messages.fontColorLabel()}
          />
        </div>
        <div>
          <ColorPicker
            color={getValue(`${fieldPrefix}BackgroundColor`) || '#FFFFFF'}
            onChange={(color) => setValueForField(`${fieldPrefix}BackgroundColor`, color)}
            label={messages.backgroundColorLabel()}
          />
        </div>
        <div>
          <label className='mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300'>
            {messages.fontFamilyLabel()}
          </label>
          <SelectField
            value={(() => {
              const currentValue = getValue(`${fieldPrefix}FontFamily`) || '';
              const allOptions: ISelectedOption[] = [
                { value: '', label: 'Default' },
                ...fontFamilyOptions,
              ];
              return allOptions.find((opt) => opt.value === currentValue) || null;
            })()}
            options={[{ value: '', label: 'Default' }, ...fontFamilyOptions]}
            onChange={(selectedOption: ISelectedOption | null) => {
              setValueForField(`${fieldPrefix}FontFamily`, selectedOption?.value || '');
            }}
            placeholder={messages.fontFamilyLabel()}
          />
        </div>
        <div className='flex flex-col'>
          <div className='mb-2 h-5'>{/* Spacer to match label height */}</div>
          <div className='flex items-center gap-4 pt-5'>
            <label className='flex items-center'>
              <input
                type='checkbox'
                checked={getValue(`${fieldPrefix}Bold`) || false}
                onChange={(e) => setValueForField(`${fieldPrefix}Bold`, e.target.checked)}
                className='form-checkbox'
              />
              <span className='ml-2 text-sm'>{messages.boldLabel()}</span>
            </label>
            <label className='flex items-center'>
              <input
                type='checkbox'
                checked={getValue(`${fieldPrefix}Italic`) || false}
                onChange={(e) => setValueForField(`${fieldPrefix}Italic`, e.target.checked)}
                className='form-checkbox'
              />
              <span className='ml-2 text-sm'>{messages.italicLabel()}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
